export default __webpack_public_path__ + "static/media/Canva_128x128.402cfe7c.webp";